import { useState, useEffect } from 'react';

interface NavbarProps {
  scrolled?: boolean;
}

export default function Navbar({ scrolled: externalScrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [internalScrolled, setInternalScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setInternalScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Use external scrolled prop if provided, otherwise use internal state
  const scrolled = externalScrolled !== undefined ? externalScrolled : internalScrolled;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 cursor-pointer group">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-eye-line text-white text-xl"></i>
            </div>
            <span className={`text-xl font-bold ${scrolled ? 'text-gray-900' : 'text-gray-900'}`}>
              Kinra Health
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            <a
              href="/"
              className={`font-medium hover:text-primary transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-gray-700'
              }`}
            >
              Home
            </a>
            <a
              href="/our-process"
              className={`font-medium hover:text-primary transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-gray-700'
              }`}
            >
              Our Process
            </a>
            <a
              href="/who-we-work-with"
              className={`font-medium hover:text-primary transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-gray-700'
              }`}
            >
              Who We Work With
            </a>
            <a
              href="/about-us"
              className={`font-medium hover:text-primary transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700' : 'text-gray-700'
              }`}
            >
              About Us
            </a>
            <a
              href="/contact"
              className="bg-primary text-white px-6 py-3 rounded-full hover:bg-primary-dark transition-all cursor-pointer whitespace-nowrap font-semibold"
            >
              Request a Demo
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center"
            aria-label="Toggle menu"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-900' : 'text-gray-900'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-6 border-t border-gray-200 pt-6 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col gap-4">
              <a
                href="/"
                className="text-gray-700 font-medium hover:text-primary transition-colors cursor-pointer px-4 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </a>
              <a
                href="/our-process"
                className="text-gray-700 font-medium hover:text-primary transition-colors cursor-pointer px-4 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Our Process
              </a>
              <a
                href="/who-we-work-with"
                className="text-gray-700 font-medium hover:text-primary transition-colors cursor-pointer px-4 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Who We Work With
              </a>
              <a
                href="/about-us"
                className="text-gray-700 font-medium hover:text-primary transition-colors cursor-pointer px-4 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                About Us
              </a>
              <a
                href="/contact"
                className="bg-primary text-white px-6 py-3 rounded-full hover:bg-primary-dark transition-all cursor-pointer whitespace-nowrap font-semibold text-center mx-4"
                onClick={() => setMobileMenuOpen(false)}
              >
                Request a Demo
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
